export default function resolver(values, t) {
  const errors = {}

  const errorMessage = t('create-edit-group.illegal-input-character')
  if (values.groupName && /[`~$^+=<>|]/.test(values.groupName)) errors.groupName = { message: errorMessage }
  if (values.groupDescription && /[`~$^+=<>|]/.test(values.groupDescription))
    errors.groupDescription = { message: errorMessage }
  if (values.groupRules && /[`~$^+=<>|]/.test(values.groupRules)) errors.groupRules = { message: errorMessage }

  return { values, errors }
}
